import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button, ButtonProps, IconButton,
  PopperPlacementType,
  Tooltip
} from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import React, { useCallback, useRef, useState } from 'react';
import { translate } from 'utils';

import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons';

const DropdownButton = ({
                          buttonStyle = {},
                          children,
                          color = 'primary',
                          disabled = false,
                          icon,
                          iconSize = 'xs',
                          isIconOnly = false,
                          isLoading = false,
                          label = '',
                          placement = 'bottom-end',
                          popperMargin = '0',
                          tooltip
                        }: {
  buttonStyle?: React.CSSProperties,
  children: React.ReactNode,
  color?: ButtonProps['color'],
  disabled?: boolean,
  icon: any,
  iconSize?: SizeProp,
  isIconOnly?: boolean,
  isLoading?: boolean,
  label?: string,
  placement?: PopperPlacementType,
  popperMargin?: string,
  tooltip?: string
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement | null>(null);

  const handleToggle = useCallback(() => setIsOpen(!isOpen), [isOpen]);
  const handleClose = useCallback(() => setIsOpen(false), []);

  const button = (isIconOnly)
      ? (
        <span>
          <IconButton
            color={color}
            disabled={disabled || isLoading}
            ref={anchorRef as React.RefObject<HTMLButtonElement>}
            style={buttonStyle}
            onClick={handleToggle}
        >
            <FontAwesomeIcon fixedWidth icon={isLoading ? faSpinner : icon} size={iconSize} spin={isLoading} />
          </IconButton>
        </span>
      )
      : (
        <Button
              color={color}
              disabled={disabled || isLoading}
              ref={anchorRef}
              startIcon={icon && <FontAwesomeIcon icon={isLoading ? faSpinner : icon} spin={isLoading} />}
              style={buttonStyle}
              variant="contained"
              onClick={handleToggle}
          >
          {translate(label)}
        </Button>
      );

  return (
    <>
      {tooltip ? (
        <Tooltip title={tooltip}>
          <span style={{ display: 'inline-block' }}>
            {button}
          </span>
        </Tooltip>
        ) : button}
      <Popper
            anchorEl={anchorRef.current}
            open={isOpen}
            placement={placement}
            style={{ zIndex: 110 }}
            transition
            onClick={handleClose}
        >
        {({ TransitionProps }) => (
          <Grow
                  {...TransitionProps}
                  style={{ transformOrigin: 'top center' }}
              >
            <Paper style={{ padding: '1rem', margin: popperMargin }}>
              <ClickAwayListener onClickAway={handleClose}>
                <div>{children}</div>
              </ClickAwayListener>
            </Paper>
          </Grow>
          )}
      </Popper>
    </>
  );
};

export default DropdownButton;
